export const SENTRY_VIEWER_SCRIPT_DSN =
  'https://77d0ecbc24e74cd698ba361c043cfbad@sentry.io/1479241';
